import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import { ViewIsLookInEnabledReturn, viewIsLookInEnabled } from "../../../../projection/lookIn/viewIsLookInEnabled";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewIsLookInEnabledFunction {
  (): UseQueryFunctionResult<ViewIsLookInEnabledReturn>;
}

const useViewIsLookInEnabled: UseViewIsLookInEnabledFunction = () =>
  useQuery({
    query: viewIsLookInEnabled(),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewIsLookInEnabled };
